{
  "pt": {
    "navbar": {
      "customer": {
        "after_care": "Pós-Venda",
        "dashboard": "Painel de controlo",
        "decisions": "Decisões",
        "documents": "Documentos",
        "inspirations": "Inspirações",
        "installments": "Finanças",
        "profile": "O seu perfil",
        "projectinfo": "Informações",
        "question_lists": "FAQ",
        "surveys": "Inquéritos",
        "ticket": {
          "new": "Nova conversa"
        },
        "tickets": "Conversas",
        "units": "Como construído"
      },
      "employee": {
        "all_projects": "Todos os Projetos",
        "client": "Perfil {client}",
        "contacts": "Contactos",
        "customer": "Cliente",
        "dashboard": "Painel de controlo",
        "employee": "Membro da equipa",
        "partner": "Parceiro",
        "profile": "O seu perfil",
        "project": {
          "after_care": "Pós-Venda",
          "decisions": "Decisões",
          "documents": "Documentos",
          "email_conversations": "Correio eletrónico de entrada",
          "info": "Informações",
          "installments": "Finanças",
          "milestones": "Marcos históricos",
          "news": "Feed de notícias",
          "question_lists": "FAQs",
          "sales": "Vendas",
          "surveys": "Inquéritos",
          "todos": "Tarefas"
        },
        "projects": "Projectos",
        "ticket": {
          "new": "Nova conversa"
        },
        "tickets": "Conversas"
      },
      "landmarks": {
        "employee": {
          "client": {
            "primary": "Navegação principal",
            "secondary": "Navegação secundária"
          }
        }
      },
      "partner": {
        "contacts": "Contactos",
        "dashboard": "Painel de controlo",
        "profile": "O seu perfil",
        "project": {
          "after_care": "Pós-Venda",
          "decisions": "Decisões",
          "documents": "Documentos",
          "tickets": "Conversas"
        },
        "projects": "Projectos"
      },
      "topnavbar": {
        "company": "Empresa",
        "helpcenter": "Centro de ajuda",
        "logout": "Sair do sistema",
        "profile": "Perfil",
        "searchTeam": "Pesquisar empresa",
        "selectTeam": "Selecionar empresa",
        "team": "Equipa"
      }
    }
  }
}